import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CONTROLS } from '../character/controls/Controls';

@Injectable({
    providedIn: 'root'
})
export class UiManagerService {
    isDisplayed = true;
    fadingOut = false;
    loadingComplete = false;
    private hasStarted = false;
    isPlayerIsAiming = true;
    isWeaponWheelDisplayed = false;
    updateControlsSubject = new BehaviorSubject(undefined);
    updateTargetVisibilitySubject = new BehaviorSubject(undefined);
    progress: number;

    toggleWeaponWheel(isWeaponWheelDisplayed: boolean): void {
        this.isWeaponWheelDisplayed = isWeaponWheelDisplayed;
    }

    displayLoadingScreen(value: boolean): void {
        if (value) {
            this.isDisplayed = true;
            this.fadingOut = false;
            this.loadingComplete = false;
        } else {
            if (this.hasStarted) {
                this.fadingOut = true;
                setTimeout(() => { this.isDisplayed = false; }, 600);
            } else {
                this.loadingComplete = true;
            }
        }
    }

    startGame(): void {
        this.hasStarted = true;
        setTimeout(() => {
            this.fadingOut = true;
            setTimeout(() => { this.isDisplayed = false; }, 600);
        }, 100);
    }

    updateControls(controls: any): void {
        this.updateControlsSubject.next(controls);
    }

    setTargetVisibility(isVisible: boolean): void {
        this.updateTargetVisibilitySubject.next(isVisible);
    }

    initDefaultControls(): void {
        this.updateControlsSubject.next(CONTROLS);
    }

    updateProgress(progress: number): void {
        this.progress = Math.max(this.progress ?? 0, progress);
    }
}
